import loadable from '@react-loadable/revised';
import type { ApplicationRoute } from 'routes/routes';
import LoadingComponent from '../../common/loader';

const routes: ApplicationRoute[] = [
    {
        component: loadable({
            loader: () => import('./pages/not-found/index.js').then((m) => m.default),
            loading: LoadingComponent,
        }),
    },
];

export default routes;
